import {
  Component,
  EventEmitter,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { filter, map, Observable, takeUntil } from 'rxjs';
import { LoadFileService, SavedSearchService } from '@pulse-front/core';

@Component({
  selector: 'pulse-file-upload',
  templateUrl: './file-upload.component.html',
  styleUrls: ['./file-upload.component.scss'],
  providers: [LoadFileService],
})
export class FileUploadComponent implements OnInit {
  @Output() fileLoaded: EventEmitter<any> = new EventEmitter<any>();

  @ViewChild('fileInput') fileInput: any;
  fileName: string;
  showFileSelector = true;

  constructor(private readonly savedSearchService: SavedSearchService) {}

  ngOnInit(): void {}

  ngAfterViewInit() {}

  loadFile(event: any) {
    const formData = new FormData();
    formData.append('file', event.target.files[0]);

    this.fileName = event.target.files[0].name;

    let service: Observable<any>;
    service = this.savedSearchService.fileUpload(formData);

    service
      .pipe(
        map((response) => {
          if (response.body) {
            this.showFileSelector = false;
            this.fileLoaded.emit(response.body.data.fileId);
          }
        })
      )
      .subscribe();
  }

  removeFile() {
    this.showFileSelector = true;
    this.fileInput.nativeElement.value = '';
    this.fileName = '';
    this.fileLoaded.emit('');
  }
}
